import { useEffect, useState } from "react";
import { LineChartDetailsCard } from "../../lineChartCard";

export const LineChartCard = ({ dataToChart, height, type, local }) => {
  const [datasets, setDatasets] = useState([]);
  const [loadingChart, setLoadingChart] = useState(true);
  useEffect(() => {
    if (type === "all") {
      setDatasets([
        {
          label: "Limite Inf",
          data: dataToChart.sensorMinThresholdValuesTemp,
          borderColor: "rgba(255, 0, 0)",
          backgroundColor: "rgba(255, 0, 0)",
          borderDash: [15, 3, 3, 3],
          borderWidth: 0.6,
          spanGaps: false,
          pointStyle: false,
        },
        {
          label: "Limite Sup",
          data: dataToChart.sensorMaxThresholdValuesTemp,
          borderColor: "rgba(255, 0, 0)",
          backgroundColor: "rgba(255, 0, 0)",
          borderDash: [15, 3, 3, 3],
          borderWidth: 0.6,
          spanGaps: false,
          pointStyle: false,
        },
        {
          label: "Temp P",
          data: dataToChart.sensor1Values,
          borderColor: "rgba(246, 167, 104)",
          backgroundColor: "rgba(246, 167, 104, 0.7)",
          lineTension: 0.5,
          borderWidth: 2,
          pointStyle: "line",
          spanGaps: false,
          yAxisID: "y2",
          hidden: true,
        },
        {
          label: "Temp S",
          data: dataToChart.sensor2Values,
          borderColor: "rgba(246, 167, 104)",
          backgroundColor: "rgba(246, 167, 104, 0.7)",
          borderDash: [5, 5],
          lineTension: 0.5,
          borderWidth: 2,
          spanGaps: false,
          yAxisID: "y2",
          pointStyle: "dash",
          hidden: true,
        },
        {
          label: "Temp Média",
          data: dataToChart.sensor9Values,
          borderColor: "rgba(189, 117, 7)",
          backgroundColor: "rgba(189, 117, 7, 0.5)",
          lineTension: 0.5,
          borderWidth: 2,
          spanGaps: false,
          yAxisID: "y2",
          pointStyle: "line",
        },
        {
          label: "Temp E",
          data: dataToChart.sensor3Values,
          borderColor: "rgba(255, 62, 62)",
          backgroundColor: "rgba(255, 62, 62, 0.5)",
          lineTension: 0.5,
          borderWidth: 2,
          spanGaps: false,
          yAxisID: "y2",
          pointStyle: "line",
        },
        {
          label: "Limite Inf",
          data: dataToChart.sensorMinThresholdValuesHum,
          borderColor: "rgb(0, 91, 180)",
          backgroundColor: "rgba(0, 91, 180)",
          borderDash: [15, 3, 3, 3],
          borderWidth: 0.6,
          pointStyle: false,
        },
        {
          label: "Limite Sup",
          data: dataToChart.sensorMaxThresholdValuesHum,
          borderColor: "rgb(0, 91, 180)",
          backgroundColor: "rgba(0, 91, 180)",
          borderDash: [15, 3, 3, 3],
          borderWidth: 0.6,
          pointStyle: false,
        },
        {
          label: "Umid P",
          data: dataToChart.sensor4Values,
          borderColor: "rgb(122, 140, 255)",
          backgroundColor: "rgba(122, 140, 255, 0.5)",
          lineTension: 0.5,
          borderWidth: 2,
          spanGaps: false,
          pointStyle: "line",
        },
        {
          label: "Umid S",
          data: dataToChart.sensor5Values,
          borderColor: "rgb(122, 140, 255)",
          backgroundColor: "rgba(122, 140, 255, 0.5)",
          showLine: true,
          borderDash: [5, 5],
          lineTension: 0.5,
          borderWidth: 2,
          spanGaps: false,
          pointStyle: "dash",
          usePointStyle: true,
        },
        {
          label: "Limite Inf",
          data: dataToChart.sensorMinThresholdValuesCO2,
          borderColor: "rgba(17, 122, 101)",
          backgroundColor: "rgba(17, 122, 101)",
          borderDash: [15, 3, 3, 3],
          borderWidth: 0.6,
          yAxisID: "y1",
          pointStyle: false,
        },
        {
          label: "Limite Sup",
          data: dataToChart.sensorMaxThresholdValuesCO2,
          borderColor: "rgba(17, 122, 101)",
          backgroundColor: "rgba(17, 122, 101)",
          borderDash: [15, 3, 3, 3],
          borderWidth: 0.6,
          yAxisID: "y1",
          pointStyle: false,
        },
        {
          label: "CO2",
          data: dataToChart.sensor6Values,
          borderColor: "rgba(0, 179, 52, 0.3)",
          backgroundColor: "rgba(0, 179, 52, 0.3)",
          showLine: true,
          lineTension: 0.5,
          borderWidth: 2,
          yAxisID: "y1",
          spanGaps: false,
          fill: true,
          pointStyle: "rect",
        },
      ]);
    } else if (type === "portAndAC") {
      setDatasets([
        {
          label: "",
          data: dataToChart.sensor71Values,
          borderColor: "rgb(255, 255, 255)",
          backgroundColor: "rgb(255, 255, 255)",
          pointStyle: "line",
          borderWidth: 0.5,
          spanGaps: false,
        },
        {
          label: "  Ar-Condicionado Ligado",
          data: dataToChart.sensor7Values,
          borderColor: "rgb(220, 120, 0)",
          backgroundColor: "rgb(220, 120, 0)",
          pointStyle: "line",
          borderWidth: 2,
          spanGaps: false,
        },
        {
          label: "Ar-Condicionado Desligado",
          data: dataToChart.sensor72Values,
          borderColor: "rgb(255, 255, 255)",
          backgroundColor: "rgb(255, 255, 255)",
          pointStyle: false,
          borderWidth: 0.5,
          spanGaps: false,
        },
        {
          label: "",
          data: dataToChart.sensor81Values,
          borderColor: "rgb(255, 255, 255)",
          backgroundColor: "rgb(255, 255, 255)",
          pointStyle: "line",
          borderWidth: 0.5,
          spanGaps: false,
        },
        {
          label: "Porta Aberta",
          data: dataToChart.sensor82Values,
          borderColor: "rgb(255, 255, 255)",
          backgroundColor: "rgb(255, 255, 255)",
          pointStyle: false,
          borderWidth: 0.5,
          spanGaps: false,
        },
        {
          label: "  Porta Fechada",
          data: dataToChart.sensor8Values,
          borderColor: "rgb(12, 100, 0)",
          backgroundColor: "rgb(12, 100, 0)",
          pointStyle: "line",
          borderWidth: 2,
          spanGaps: false,
        },
      ]);
    }

    setLoadingChart(false);
  }, [dataToChart]);

  if(!loadingChart){
    return (
      <LineChartDetailsCard
        labels={dataToChart.labels}
        datasets={datasets}
        height={height}
        type={type}
        local={local}
      />
  
    );
  }
};
